import {useFormContext} from 'react-hook-form';
import AppButton from '../../../../../../../components/common/AppButton';
import {SVG} from '../../../../../../../constants/assetLists';
import {
  NetworkDetailsFormValues,
  NetworkNodeFieldPath,
} from '../../../types';
import {downloadOnboardingChecklistExcelTemplate} from './checklistExcelTemplate';

type Props = {
  selectedFieldPath: NetworkNodeFieldPath;
};

function ChecklistsHeader({selectedFieldPath}: Props) {
  const {watch} = useFormContext<NetworkDetailsFormValues>();

  const nodeName = watch(`${selectedFieldPath}.name`) || '';

  const handleDownloadTemplate = () => {
    downloadOnboardingChecklistExcelTemplate({nodeName});
  };

  return (
    <div className="pb-2">
      <div>
        <p className="m-0 text-xl text-deepAqua font-bold">הוספת צ’קליסטים</p>

        <p className="m-0 mt-2 text-base text-darkerGray">
          הוסיפו צ’קליסטים למערכת. תוכלו לעשות זאת גם אחר כך.
        </p>
      </div>

      <div className="mt-1">
        <div className="flex justify-end">
          <AppButton
            onClick={handleDownloadTemplate}
            iconStart={
              <img
                src={SVG.excelGreenIcon}
                className="w-[18px] h-[18px] object-contain"
              />
            }>
            הורידו תבנית אקסל לצ’קליסט
          </AppButton>
        </div>
      </div>
    </div>
  );
}

export default ChecklistsHeader;
